const ScrollSpeed = ( function( settings ) {
	settings = settings || {};

	let lastPos, newPos, timer, delta;
	const delay = settings.delay || 50; // in "ms" (higher means lower fidelity )

	function clear() {
		lastPos = null;
		delta = 0;
	}

	clear();

	return function() {
		newPos = window.scrollY;
		if ( lastPos !== null ) {
			// && newPos < maxScroll
			delta = newPos - lastPos;
		}
		lastPos = newPos;
		clearTimeout( timer );
		timer = setTimeout( clear, delay );
		return Number( delta );
	};
}() );

export default ScrollSpeed;
